import { graphql } from "gatsby"
import React from "react"

import PriceSlider from "@knowit-alma/common/src/components/organisms/PriceSlider/PriceSlider"

const PriceSliderBlock = ({ blockDataPriceSlider }) => {
  const { heading, values } = blockDataPriceSlider || {}
  return <PriceSlider heading={heading} slides={values} />
}

export const query = graphql`
  fragment PriceSlider on WpBlockAcfPriceSlider {
    __typename
    blockDataPriceSlider {
      heading
      values {
        value
        description
        price
        priceDescription
        subtext
      }
    }
  }
`

export default PriceSliderBlock
